<template>
  <!-- Sidebar -->
  <div class="sidebar" id="sidebar">
    <perfect-scrollbar
      class="scroll-area"
      :settings="settings"
      @ps-scroll-y="scrollHanle"
    >
      <div class="sidebar-inner slimscroll">
        <div id="sidebar-menu" class="sidebar-menu">
          <ul>
            <li class="clinicdropdown">
              <a href="#">
                <img
                  :src="userProfilePicture"
                  class="img-fluid"
                  alt="Profile"
                />
                <div class="user-names">
                  <h5>{{ userInfo?.name }}</h5> <p style="color:#000;text-transform: capitalize;">{{userRoles[0]}}</p>
                </div>
              </a>
            </li>
          </ul>
          <vertical-sidebar></vertical-sidebar>
        </div>
      </div>
    </perfect-scrollbar>
  </div>
  <!-- /Sidebar -->
</template>

<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
import { mapGetters } from "vuex";

export default {
  components: {
    PerfectScrollbar,
  },
  data() {
    return {
      settings: {
        suppressScrollX: true,
      },
    };
  },
  methods: {
    scrollHanle() {},
  },
  computed: {
    ...mapGetters(["userInfo","userRoles"]),

    userProfilePicture() {
      if (
        !this.userInfo ||
        !this.userInfo.employee ||
        !this.userInfo.employee.profile_picture
      ) {
        return require("@/assets/img/profiles/avatar-14.jpg");
      }
      return this.userInfo.employee.profile_picture;
    },
  },
};
</script>
